import { getShapeParts, getShapeViewBox } from './shapes';

/**
 * One side shape, identical in the editor and in saved markup.
 *
 * Purely decorative — a wreath around a number carries nothing a reader could
 * miss, and the number and its label are already in the text — so it is hidden
 * from assistive tech rather than given a label nobody wants read aloud.
 *
 * Colour comes from `currentColor` throughout, so a single custom property on
 * the wrapper tints every part without the catalogue knowing anything about
 * theme colours.
 *
 * @param {Object} props       Component props.
 * @param {string} props.shape Catalogue key.
 * @return {Element|null} SVG element, or null when the shape is switched off.
 */
export default function MedalShape({ shape }) {
  const parts = getShapeParts(shape);

  if (!parts.length) {
    return null;
  }

  return (
    <svg
      className="brandy-medal__shape-svg"
      viewBox={getShapeViewBox(shape)}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {parts.map((part, index) =>
        part.stroke ? (
          <path
            key={index}
            d={part.d}
            stroke="currentColor"
            strokeWidth={part.stroke}
            strokeLinecap="round"
          />
        ) : (
          <path key={index} d={part.d} fill="currentColor" />
        )
      )}
    </svg>
  );
}
